import * as React from 'react';
import { Link } from 'react-router';
import styles from './NewBreadcrumb.module.css';

export interface NewBreadcrumbItem {
  label: string;
  to?: string;
}

interface NewBreadcrumbProps {
  items: NewBreadcrumbItem[];
  grayAncestors?: boolean;
}

export const NewBreadcrumb: React.FC<NewBreadcrumbProps> = ({ items, grayAncestors }) => (
  <nav className={styles.breadcrumb}>
    {items.map((item, idx) => (
      <React.Fragment key={idx}>
        {idx > 0 && <i className={`fa-solid fa-chevron-right ${styles.sep}`} />}
        {item.to
          ? <Link to={item.to} className={`${styles.link}${grayAncestors && idx < items.length - 1 ? ` ${styles.grayAncestor}` : ''}`}>{item.label}</Link>
          : <span className={`${styles.current}${grayAncestors && idx < items.length - 1 ? ` ${styles.grayAncestor}` : ''}`}>{item.label}</span>
        }
      </React.Fragment>
    ))}
  </nav>
);
